"use strict";

exports.__esModule = true;
exports.isLocalLink = void 0;
// Copied from https://github.com/sindresorhus/is-absolute-url/blob/3ab19cc2e599a03ea691bcb8a4c09fa3ebb5da4f/index.js
var ABSOLUTE_URL_REGEX = /^[a-zA-Z][a-zA-Z\d+\-.]*?:/;

var isAbsolute = function isAbsolute(path) {
  return ABSOLUTE_URL_REGEX.test(path);
};

var isLocalLink = function isLocalLink(path) {
  if (typeof path !== "string") {
    return undefined; // TODO(v5): Re-Add TypeError
    // throw new TypeError(`Expected a \`string\`, got \`${typeof path}\``)
  }

  return !isAbsolute(path);
};

exports.isLocalLink = isLocalLink;